/* eslint-disable no-undef */
// project imports
import services from 'utils/mockAdapter';
// import { product } from 'data/e-commerce';
import product from 'data/ghgVehicle.json';

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/ghgVehicle/list').reply(200, { product });

services.onPost('/api/ghgVehicle/filter').reply((config) => {
  try {
    const { filter } = JSON.parse(config.data);

    if (filter.sort === 'high') {
      product.sort((a, b) => Number(b.offerPrice) - Number(a.offerPrice));
    }

    if (filter.sort === 'low') {
      product.sort((a, b) => Number(a.offerPrice) - Number(b.offerPrice));
    }

    // if (filter.sort === 'popularity') {
    //   product.sort((a, b) => Number(b.popularity) - Number(a.popularity));
    // }

    if (filter.sort === 'stock') {
      product.sort((a, b) => Number(b.stock) - Number(a.stock));
    }

    // if (filter.sort === 'new') {
    //   product.sort((a, b) => Number(b.new) - Number(a.new));
    // }

    const results = product.filter((product) => {
      let searchMatches = true;

      if (filter.search) {
        const properties = ['name', 'description', 'rating', 'offerPrice'];
        let containsQuery = false;

        properties.forEach((property) => {
          if (product[property] && product[property].toString().toLowerCase().includes(filter.search.toString().toLowerCase())) {
            containsQuery = true;
          }
        });

        if (!containsQuery) {
          searchMatches = false;
        }
      }

      // const genderMatches = filter.gender.length > 0 ? filter.gender.some((item) => item === product.gender) : true;
      const categoriesMatches =
        filter.categories.length > 0 && filter.categories.some((category) => category !== 'all')
          ? filter.categories.some((category) => product.categories.some((item) => item === category))
          : true;
      // const colorsMatches = filter.colors.length > 0 ? filter.colors.some((color) => product.colors.some((item) => item === color)) : true;

      const minMax = filter.price ? filter.price.split('-') : '';
      const priceMatches = filter.price ? product.offerPrice >= minMax[0] && product.offerPrice <= minMax[1] : true;
      const ratingMatches = filter.rating > 0 ? product.rating >= filter.rating : true;

      return searchMatches && categoriesMatches && priceMatches && ratingMatches;
    });

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/ghgVehicle/details').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    let results;
    if (id === 'default') {
      [results] = product;
    } else {
      // eslint-disable-next-line
      [results] = product?.filter((product) => product.id === Number(id));
    }

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/ghgVehicle/related').reply((config) => {
  try {
    const { id } = JSON.parse(config.data);

    const results = product.filter((product) => product.id !== Number(id));

    return [200, results];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/ghgVehicle/list/single').reply((config) => {
  try {
    const result = product.find((e) => e.id === Number(config.data));
    return [200, result];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/ghgVehicle/insert').reply((config) => {
  try {
    let list = JSON.parse(config.data);
    list = {
      ...list,
      id: product.length + 1
    };
    product.push(list);
    return [200, { list }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});

services.onPost('/api/ghgVehicle/update').reply((config) => {
  try {
    const list = JSON.parse(config.data);

    let NewProduct = null;
    _.map(product, (_list) => {
      if (_list.id === list.id) {
        _.assign(_list, { ...list });
        NewProduct = _list;
      }
      return _list;
    });

    return [200, { NewProduct }];
  } catch (err) {
    console.error(err);
    return [500, { message: 'Internal server error' }];
  }
});
